<div
  class="border-t border-borders-light dark:border-borders-darker px-2 pt-2 pb-1 mobile:p-3"
>
  @if (disabled) {
  <p class="!m-0 text-sm text-grey dark:text-lightGrey">
    {{ readOnlyReason | translate }}
  </p>
  } @else {
  <div
    #suggestionsRail
    class="mb-1.5 overflow-x-auto pb-0.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    (scroll)="updateSuggestionsMask()"
  >
    <div class="flex w-max min-w-full gap-1">
      @for (suggestion of suggestions; track suggestion) {
      <button
        type="button"
        class="shrink-0 rounded-full border border-borders-light dark:border-borders-darker bg-whiteshade dark:bg-black-dark-lighter px-1.5 py-1 text-xs font-bold hover:border-primary focus-visible:outline-primary"
        [disabled]="sending"
        (click)="suggest(suggestion)"
      >
        {{ suggestion }}
      </button>
      }
    </div>
  </div>
  @if (spoiler) {
  <p class="!m-0 mb-1! text-xs text-primary font-bold" role="status">
    {{ "DISCUSSION.SPOILER_HINT" | translate: {name: recipient} }}
  </p>
  }
  <div class="flex items-end gap-1">
    <div
      class="flex items-end min-w-0 flex-1 rounded-2xl border border-borders-light dark:border-borders-darker bg-whiteshade dark:bg-black-dark-lighter focus-within:border-primary"
      [class.border-primary]="spoiler"
    >
      <textarea
        #input
        class="!m-0 !border-0 !bg-transparent !shadow-none !p-1.5 resize-none min-h-[50px] max-h-[120px] w-full max-mobile:text-[16px]"
        rows="2"
        maxlength="2000"
        [(ngModel)]="text"
        (input)="typing.emit(!!input.value.trim())"
        (blur)="typing.emit(false)"
        [disabled]="sending"
        (keydown)="keydown($event)"
        [attr.aria-label]="
          'DISCUSSION.PLACEHOLDER' | translate: {name: recipient}
        "
        [placeholder]="'DISCUSSION.PLACEHOLDER' | translate: {name: recipient}"
      ></textarea>
      <button
        type="button"
        class="shrink-0 m-1 p-1 rounded-full hover:bg-primary/10"
        [class.text-primary]="spoiler"
        [disabled]="sending"
        [attr.aria-pressed]="spoiler"
        [attr.aria-label]="'DISCUSSION.SPOILER' | translate"
        [title]="'DISCUSSION.SPOILER' | translate"
        (click)="spoiler = !spoiler"
      >
        <span
          class="block w-[20px] h-[20px] bg-current mask-[url(/assets/images/icons/eye-slash.svg)] mask-contain mask-no-repeat mask-center"
        ></span>
      </button>
    </div>
    <button
      type="button"
      class="flex items-center justify-center w-[44px] h-[44px] mb-0.5 rounded-full bg-primary text-black disabled:opacity-30 shrink-0"
      [disabled]="sending || !text.trim()"
      (click)="send()"
      [attr.aria-label]="'DISCUSSION.SEND' | translate"
    >
      <span class="text-xl" aria-hidden="true">↑</span>
    </button>
  </div>
  @if (!mobileInput) {
  <p class="!mb-0 !mt-1 text-right text-xs text-grey dark:text-lightGrey">
    {{ "DISCUSSION.KEYBOARD_HINT" | translate }}
  </p>
  } }
</div>
